import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiService } from '@shared/services/api.service';

import { LicenseConfiguration } from './license-configuration';

@Injectable()
export class LicenseConfigurationService extends ApiService<
  LicenseConfiguration
> {
  constructor(http: HttpClient) {
    super(http);
  }

  getLicenseName() {
    return this.get({ url: 'license/type', responseType: 'text' });
  }

  getConfiguration() {
    return this.get({ url: 'v2/license/configuration/' });
  }

  loadLicenseExtensions() {
    return this.get({ url: 'license/extension' });
  }
}
